var React = require('react');
var $ = require('jquery');

// import Select from 'react-select';
// import 'react-select/dist/react-select.css';
// import Select2 from 'react-select2-wrapper';
// import 'react-select2-wrapper/css/select2.css';
import RaisedButton from 'material-ui/RaisedButton';

// import {Typeahead} from 'react-bootstrap-typeahead';


var AddQuestion = React.createClass({
    questionTypes: [{
        title: "Multiple Choice",
        value: 11
    }, {
        title: "Short Answer",
        value: 21
    }, {
        title: "Long Answer",
        value: 22
    }],
    Points: [{
        title: 1,
        value: 1
    }, {
        title: 2,
        value: 2
    }, {
        title: 3,
        value: 3
    }, {
        title: 4,
        value: 4
    }, {
        title: 5,
        value: 5
    }],
    getInitialState: function() {
        return {
            conceptsMap: {},
            conceptId: "0",
            questionType: "0",
            Point: "0",
            QuestionsData: []
        };
    },
    handelConceptChange: function(e) {
        this.setState({
            conceptId: e.target.value
        }, function(){
            this.handelAddQuestion();
        })
    },
    handelPointChange: function(e){
        this.setState({
            Point: e.target.value
        }, function(){
            this.handelAddQuestion();
        })
    },
    handelQuestionTypeChange: function(e){
        this.setState({
            questionType: e.target.value
        }, function(){
            this.handelAddQuestion();
        })
    },
    handelAddQuestion: function() {
        var _this = this;
        var conditions = {
            status: "public"
        }
        if (this.state.conceptId != "0") {
            conditions.concepts = {
                "$in": [_this.state.conceptId]
            }
        }
        if (this.state.Point != 0) {
            conditions.score = this.state.Point;
        }
        if (this.state.questionType != 0) {
            conditions.type = this.state.questionType;
        }
        this.props.retrieveQuestionsOfConcept(conditions, function(err, data) {
            _this.setState({
                QuestionsData: (!err && data) ? data : []
            });
        })
    },
    choisenItem: function(Question){
            if(this.props.currentQuestions[Question._id]){
                    this.props.deleteQuestionCollection(this.props.collection._id, Question._id);
            }else{
                    this.props.addQuestionCollection(this.props.collection._id, Question);
            }
    },
    GenarateQuestionsData: function() {
        var _this = this;
        return (
            <div className="row questions-area">
                {
                     _this.state.QuestionsData.map(function(Question, index) {
                            return (
                                <div className="col-md-4 add-question-item" key={"Question" + index}  onClick={_this.choisenItem.bind(this, Question)}>
                                         <p className="question-title"> {index +1} . {Question.score} Points
                                                 <span className={`${_this.props.currentQuestions[Question._id] ? 'chosen-item' : ''}`}><i className="fa fa-check-circle-o" aria-hidden="true"></i></span>
                                         </p>
                                         <span dangerouslySetInnerHTML={{__html: Question.description.substring(0, (Question.image?50:250) ) || 'No title'}}></span>
                                            {Question.description.length>50&&Question.image&&<span>...</span>}
                                            {Question.description.length>300&&!Question.image&&<span>...</span>}
                                           { Question.image && 
                                                <div className="col-md-10" style={{"margin-top": "-10px"}}>
                                                        <img className="img-responsive"  src={Question.image}  style={{ "height": "75px", "margin": "10px auto"}} />
                                                </div>
                                          }
                                </div>
                            )
                        })
                }
            </div>
        )
    },

    isConceptsOfCurrentCourse: function(currentConceptId, destConceptId) {
        var _this = this;
        var conceptsMap = _this.props.conceptsMap;
        var currentConcept = conceptsMap[currentConceptId];
        if (!currentConcept) {
            return false;
        } else if (currentConceptId === destConceptId) {
            return true;
        } else {
            return _this.isConceptsOfCurrentCourse(currentConcept.upperConcept, destConceptId)
        }
    },

    preBuildConceptsMap: function(callback) {
        callback = callback || function() {};
        var _this = this;
        var conceptsMap = _this.props.conceptsMap;
        var currentCourse = _this.props.course;
        var courseConceptId = "";

        for (var conceptId in conceptsMap) {
            if (conceptsMap[conceptId].title == currentCourse) {
                courseConceptId = conceptId;
                break;
            }
        }

        var result = [];
        for (var conceptId in conceptsMap) {
            if (conceptId === courseConceptId) continue;
            if (_this.isConceptsOfCurrentCourse(conceptId, courseConceptId)) {
                result.push(conceptId);
            }
        }
        this.setState({
            conceptsMap: result
        })
    },


    render: function() {
        var _this = this;

        // var options = [
        //     { text: 'discussion 12', id: 3 },
        // ];


        var i = 0;
        // for (var concept in _this.props.conceptsMap) {
        //     options.push({
        //         text: _this.props.conceptsMap[concept].title,
        //         id: _this.props.conceptsMap[concept]._id
        //     });
        // }
        return (
                        <div className="add-question">
                                 {(_this.props.collection.status === "to_be_reviewed") &&
                                    <div>
                                                     <div className="row">
                                                                     <div className="col-md-8">
                                                                               <h2 className="head-view-title">+ Add More Questions</h2>
                                                                      </div>
                                                             
                                                                     <div className="col-md-4" style={{"margin-top":"10px"}}>
                                                                             <RaisedButton
                                                                                    label="PART 1"
                                                                                    labelColor="white"
                                                                                    onClick={_this.props.setCurrentPart.bind(this, "PART_1")}
                                                                                    backgroundColor={_this.props.currentPart=="PART_1"?"#4dc3ca":"#999999"}
                                                                                    />
                                                                            <RaisedButton
                                                                                    label="PART 2"
                                                                                    labelColor="white" 
                                                                                    onClick={_this.props.setCurrentPart.bind(this, "PART_2")}
                                                                                    backgroundColor={_this.props.currentPart=="PART_2"?"#4dc3ca":"#999999"}
                                                                                    />
                                                                     </div>
                                                     </div>
                                                    <div className="row form-inline combobox-group combobox-group-question">
                                                                   <div className="col-md-4 form-group">
                                                                                <label className="control-label">Concept:</label>
                                                                               <select className="form-control input-medium" onChange={_this.handelConceptChange} value={_this.state.conceptId?_this.state.conceptId:"0"}>
                                                                                 <option value="0">Chosen Concept</option>
                                                                                {
                                                                                    _this.state.conceptsMap.map(function(concept, index) {
                                                                                        return(
                                                                                                <option value={_this.props.conceptsMap[concept]._id}>{_this.props.conceptsMap[concept].title}</option>
                                                                                            )
                                                                                    })
                                                                                }
                                                                            </select>
                                                                  </div>
                                                                    <div className="col-md-4 form-group">
                                                                        <label className="control-label">Type of Questions:</label>
                                                                        <select className="form-control custom-option" onChange={_this.handelQuestionTypeChange} value={_this.state.questionType?_this.state.questionType:0}>
                                                                            <option value={0}>Chosen Questions Type</option>
                                                                            {
                                                                                _this.questionTypes.map(function(questionType, index){
                                                                                    return <option value={questionType.value}>{questionType.title}</option>
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-md-4 form-group">
                                                                        <label className="control-label">Point:</label>
                                                                        <select className="form-control custom-option" onChange={_this.handelPointChange} value={_this.state.Point?_this.state.Point:0}>
                                                                             <option value={0}>Chosen Questions Point</option>
                                                                            {
                                                                                _this.Points.map(function(Point, index){
                                                                                    return <option value={Point.value}>{Point.title}</option>
                                                                                    // if (index === 0) {
                                                                                    //     return <option value={Point.value} selected>{Point.title}</option>
                                                                                    // } else {
                                                                                    //     return <option value={Point.value}>{Point.title}</option>
                                                                                    // }
                                                                                })
                                                                            }
                                                                        </select>
                                                                        <div className="sort-button" onClick={_this.handelSortQuestion}><i className="fa fa-sort-alpha-asc" aria-hidden="true"></i></div>
                                                                    </div>
                                                    </div>
                                </div>
                                }
                                {_this.GenarateQuestionsData()}
                                <div className="row">
                                        {_this.state.QuestionsData.length>0&&
                                            <button type="button" className="btn btn-info button-done-add-question" onClick={_this.CompleteAddQuestion}>Done</button>
                                        }
                                </div>
                         </div>
        )
    },
    handelSortQuestion: function(){
        this.props.sortQuestion();
        this.props.calculatorDataCollection(this.props.collection);        
    },
    CompleteAddQuestion: function(){
        this.setState({
            QuestionsData: [],
            questionType: 0,
            Point: 0,
            conceptId: "0"
        })
    },
    componentWillMount: function() {
        this.preBuildConceptsMap();
    }
})

export default AddQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/ExamEditor/AddQuestion.js
 **/